import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles(() => ({
  loadMoreContainer: {
    paddingTop: 20,
    margin: 10,
  },
}));
